/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const LegalContract56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M12 14a8 8 0 110 16 8 8 0 010-16zM36 4a4 4 0 110 8 4 4 0 010-8z" fill={vars.bdlBoxBlue10} />
            <path d="M15 8h25a3 3 0 013 3v33a3 3 0 01-3 3H12V11a3 3 0 013-3z" fill={vars.white} />
            <path
                d="M49.5 51a.5.5 0 110 1h-13a.5.5 0 110-1h13zM40 6a5 5 0 014.995 4.783L45 11l.001 19.57a3.79 3.79 0 011.792 3.223l-.002.136-.007.135-.71 9.936H49a3 3 0 012.995 2.824L52 47v1a2 2 0 01-1.85 1.995L50 50H36a2 2 0 01-1.995-1.85L34 48H9a4 4 0 01-3.995-3.8L5 44v-6h6V11a5 5 0 014.783-4.995L16 6h24zm9 40h-5a4.993 4.993 0 01-3.783 1.995L40 48h10v-1a1 1 0 00-1-1zM40 8H16a3 3 0 00-2.995 2.824L13 11v33c0 .729-.195 1.413-.536 2.001h21.707a3.002 3.002 0 012.653-1.996L37 44h2.925l-.709-9.936a3.794 3.794 0 013.32-4.036l.194-.018c.09-.007.18-.01.27-.01V11a3 3 0 00-2.824-2.995L40 8zM11 40H7v4a2 2 0 001.697 1.977l.154.018L9 46a2 2 0 001.995-1.85L11 44v-4zm32.001-8H43l-.128.005a1.794 1.794 0 00-1.665 1.769l.004.147.72 10.079h.898c.092-.26.15-.536.166-.824L43 43l.001-11zM34.5 39a.5.5 0 110 1h-13a.5.5 0 110-1h13zm0-3a.5.5 0 110 1h-13a.5.5 0 110-1h13zm0-3a.5.5 0 110 1h-13a.5.5 0 110-1h13z"
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
            />
            <path
                d="M7 40h4v4a2 2 0 01-2 2l-.15-.005A2 2 0 017 44v-4zM44.793 33.793l-.004.128L44.068 44h-2.137l-.72-10.079a1.793 1.793 0 011.661-1.916L43 32c.99 0 1.793.803 1.793 1.793zM37 46h12a1 1 0 011 1v1H36v-1a1 1 0 011-1z"
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
            />
            <path
                d="M34 15c1 3.667.333 6.667-2 9-2.261 2.261-5.149 2.957-8.662 2.088l-2.547 1.819a.5.5 0 01-.65-.755l.068-.059 2.875-2.054c.342-3.09 1.314-5.437 2.916-7.039 1.764-1.764 4.431-2.764 8-3zm-1.603 2.189l-.099.016c-2.174.367-3.79 1.115-4.884 2.21-.937.936-1.62 2.254-2.027 3.978l1.822-1.3a.5.5 0 01.65.755l-.068.059-2.142 1.53c1.89.114 3.438-.445 4.749-1.67l.188-.181c1.43-1.43 2.04-3.144 1.823-5.29l-.012-.107z"
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
            />
        </g>
    </AccessibleSVG>
);

export default LegalContract56;
